import { Suspense, lazy } from "react";
import MaterialLayout from "hoc/materialLayout";
import Wrapper from "hoc/wrapper";
import ScrollToTop from "components/ScrollToTop";
import LazyLoadingFallback from "Core/components/LazyLoadingFallback";

const DAIEditorRoutes = lazy(() => import("DAIEditor/routes"));
const DAIRoutes = lazy(() => import("DAI/routes"));

export default function DeciphrRoutes() {
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const isDAIAccount = userInfo && userInfo.org_role === null;

  return (
    <Suspense fallback={<LazyLoadingFallback />}>
      <ScrollToTop />

      <MaterialLayout>
        <Wrapper>
          <DAIEditorRoutes />
          <DAIRoutes isEnabled={isDAIAccount} />
        </Wrapper>
      </MaterialLayout>
    </Suspense>
  );
}
